<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">Top Trades</h4>
                                <h5 class="card-subtitle">Overview of your recent trades</h5>
                            </div>
                            <div class="ml-auto">
                                <div class="dl">
                                    <select class="custom-select">
                                        <option selected="" value="0">Sort By</option>
                                        <option value="1">Pending</option>
                                        <option value="2">Shipped</option>
                                        <option value="3">Archived</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-body" v-if="trades.length>0">
                        <div class="table-responsive">
                            <table class="table v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0">Status</th>
                                    <th class="border-0">Commodity</th>
                                    <th class="border-0">Trader</th>
                                    <th class="border-0">Created On</th>
                                    <th class="border-0">Quantity</th>
                                    <th class="border-0">Price</th>
                                    <th class="border-0">Total</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr @click="viewTrade(trade.trade_id)" style="cursor: pointer;" v-bind:key="index" v-for="(trade, index) in trades">
                                    <td class="v-align-t">
                                        <span class="label label-cyan" v-if="trade.status === 'OPEN'">Open</span>
                                        <span class="label label-indigo" v-if="trade.status === 'ACCEPTED'">Accepted</span>
                                        <span class="label label-grey text-white" v-if="trade.status === 'CANCELLED'">Cancelled</span>
                                        <span class="label label-brown" v-if="trade.status === 'SIGNED'">Signed</span>
                                        <span class="label label-orange" v-if="trade.status === 'ESCROWED'">Escrowed</span>
                                        <span class="label label-orange" v-if="trade.status === 'PAYMENT'">Payment</span>
                                        <span class="label label-ink" v-if="trade.status === 'SCHEDULED'">Scheduled</span>
                                        <span class="label label-yellow" v-if="trade.status === 'SHIPPED'">Shipped</span>
                                        <span class="label label-light-green" v-if="trade.status === 'RELEASED'">Released</span>
                                        <span class="label label-dark-green" v-if="trade.status === 'COMPLETE'">Complete</span>
                                    </td>
                                    <td class="v-align-t"><h4 class="m-b-0 font-16">{{trade.commodity_name}}</h4></td>
                                    <td class="v-align-t">
                                        <div class="d-flex no-block align-items-center">
                                            <div class="m-r-10">
                                                <blockie :address="getTraderName(trade)"></blockie>
                                            </div>
                                            <div class="">
                                                <h5 class="m-b-0 font-16 font-medium">{{getTraderName(trade)}}</h5>
                                                <span>{{getTradeType(trade)}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="v-align-t">{{trade.created_at | timeline}}</td>
                                    <td class="v-align-t">{{trade.quantity | count}} {{trade.unit.symbol}}</td>
                                    <td class="v-align-t" v-if="trade.unit_price">{{trade.unit_price | money}} / {{trade.unit.symbol}}</td>
                                    <td class="v-align-t" v-if="!trade.unit_price">0.00 / {{trade.unit.symbol}}</td>
                                    <td class="v-align-t"><h5 class="m-b-0" v-if="trade.total_amount">{{trade.total_amount | money}}</h5></td>
                                    <td class="v-align-t"><h5 class="m-b-0" v-if="!trade.total_amount">0.00</h5></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                      <div class="row">
                        <div class="col-12">
                          <paginate
                              :click-handler="pageHandler"
                              :container-class="'pagination float-right'"
                              :margin-pages="2"
                              :next-class="'page-link'"
                              :next-text="'Next'"
                              :page-class="'page-link'"
                              :page-count=pageCount
                              :page-range="3"
                              :prev-class="'page-link'"
                              :prev-text="'Prev'">
                          </paginate>
                        </div>
                      </div>
                    </div>
                    <div class="card-body mb-3" v-else>
                        <h4 class="card-title text-muted text-center">No records found</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';
    import Blockie from "../../common/Blockie";
    import Money from "../../../../models/Money";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "MyTrades",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"]),
            selectAll: {
                get: function() {
                    return this.statuses
                    ? this.filters.status.length == this.statuses.length
                    : false;
                },
                set: function(value) {
                    let selected = [];

                    if(value) {
                        this.statuses.forEach(function(status) {
                            selected.push(status);
                        });
                    }

                    this.filters.status = selected;
                }
            }
        },
        components: {Blockie, Paginate},
        data() {
            return {
                statuses: [
                    "OPEN",
                    "ACCEPTED",
                    "CANCELLED",
                    "SIGNED",
                    "ESCROWED",
                    "PAYMENT",
                    "SCHEDULED",
                    "SHIPPED",
                    "PAID",
                    "COMPLETE"
                ],
                filters: {
                    commodity: "",
                    fromDate: "",
                    toDate: "",
                    fromAmount: "",
                    toAmount: "",
                    status: []
                },
                commodities: [],
                trades: [],
                pageCount: 1,
                total: 0,
                perPage: 10,
            };
        },
        beforeMount() {
            this.getTrades(1);
        },
        mounted: function() {
            // this.getAvailableCommodity();
            this.init();
        },
        methods: {
            init() {
                $(".input-group.date").datepicker({
                    keyboardNavigation: false,
                    forceParse: false,
                    autoclose: true
                });
            },
            getTrades(page) {
              this.filters['page'] = page;
              this.filters['perPage'] = this.perPage;
                $(".preloader").fadeIn();
                this.$http
                .get("/trades", {
                    params: this.filters
                })
                .then(result => {
                    $(".preloader").fadeOut();
                    this.trades             = result.data.trades;
                    this.total              = result.data.total;
                    this.setPageCount();
                    this.trade.total_amount = new Money(this.trade.total_amount);
                    localStorage.tradeids   = JSON.stringify(_.map(this.trades, 'id'));
                })
                .catch(err => {
                    $(".preloader").fadeOut();
                    console.log(err);
                });
            },
            pageHandler(pageNum) {
              this.getTrades(pageNum);
            },
            setPageCount() {
              this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            getTraderName(trade) {
                return this.currentUser.id === trade.buyer_id ? trade.seller_first_name + ' ' + trade.seller_last_name : trade.buyer_first_name + ' ' + trade.buyer_last_name;
            },
            getTradeType(trade) {
                return this.currentUser.id === trade.buyer_id ? 'Seller' : 'Buyer';
            },
            viewTrade(tradeid) {
                this.$router.push({name: "viewtrade", params: {tradeid: tradeid}});
                // if(_.find(this.trades, {trade_id: tradeid}).contract_type === 'FORWARD') {
                //     this.$router.push({name: "forwardtrade", params: {tradeid: tradeid}});
                // } else if(_.find(this.trades, {trade_id: tradeid}).contract_type === 'SPOT') {
                //     this.$router.push({name: "spottrade", params: {tradeid: tradeid}});
                // }
            },
            getAvailableCommodity() {
                this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/commodities/name").then(commodities => {
                    this.commodities = commodities.data;
                });
            }
        }
    };
</script>

<style scoped>

</style>
